import { computed } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface';
import componentPresenter from '@/presenters/component-presenter';
import store from '@/store';

export default class InternalNotesInputCode {

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public internalNotes = computed((): string => {
		return store.getters.internalNotes();
	});

	public async mounted(): Promise<void> {
		await componentPresenter.loadTinyMCEComponent();
	}
}
